import type { ResourceDescriptor } from '@/services/uiActions/resources'
import { requireResourceId } from '@/services/uiActions/resources'
import { skill as skillRoute, skillNew } from '@constants/routing'

export const skillResource: ResourceDescriptor = {
  kind: 'skill',
  routes: {
    ui_create_skill: () => skillNew(),
    ui_update_skill: operation => skillRoute(requireResourceId(operation)),
    ui_delete_skill: operation => skillRoute(requireResourceId(operation)),
  },
}
